import { createContext } from 'react'

export interface FormStateContextType {
  hasUnsavedChanges: boolean
  setHasUnsavedChanges: (value: boolean) => void
  handleSectionChange: (section: string) => void
}

export const FormStateContext = createContext<FormStateContextType>({
  hasUnsavedChanges: false,
} as FormStateContextType)

export interface FormEntityContextType {
  entityType: string
  i18nPrefix: string
}

export const FormEntityContext = createContext<FormEntityContextType>({
  entityType: '',
  i18nPrefix: 'forms.fields',
} as FormEntityContextType)
